$(document).ready(function(){
  
    
  
var loadedVal = document.getElementsByClassName('single-option-selector')[0].value;
  
  
          
if(loadedVal) {
  
  changeOption(loadedVal);
  
  
} else {
  
  changeOption("5m");
  
  
}
  
  
 
  
 
    document.getElementsByClassName('single-option-selector')[0].addEventListener('change', function () {
  
  
  changeOption(this.value);
  


});
  
  document.getElementsByClassName('single-option-selector')[1].addEventListener('change', function () {
  
  
  changeOption(document.getElementsByClassName('single-option-selector')[0].value);
  


});
  

  }); // DOC READY
    

  
  function changeOption(thisvalue) {
  

  var options = document.getElementsByClassName('choose-size');
  
  

  for (i = 0; i < options.length; i++) {
    
    var id = options[i].getAttribute("id");
       document.getElementById(id).style.display = "none";
  }

  
       for (i = 0; i < options.length; i++) {
       
         
       var idVal = thisvalue.replace(/m.*/i, "");
       var id = new String(options[i].getAttribute("id"));
       var id = id.replace(/m.*/i, "");
      
         //-var num1 = new Number(id);
		//-var num2 = new Number(idVal);
         //-alert(num1 + " " + num2);
          
       if(id === idVal) {
       document.getElementById(id + "m").style.display = "block";
         
         var sizes = $("#accordion1 .panel-body").html();
         
         var selects = "";
         
         
         $(".single-option-selector").each(function(){
           
           selects += $(this).val();
           
           
         });
         
         var select_text = new String(selects);
         
         $("#tabs-1").html(sizes); 
         
         if(selects.includes("Yes")) {
           
           
           $("#" + id + "m .option-details-content:eq(1)").show();
           
         } else {
           
           $("#" + id + "m .option-details-content:eq(1)").hide();
         }
         
         
       
         //$("#tabs-1").hide();
         
         $("#collapse1").css("height","auto");
          
         
       } else {

       }
         
}

}